(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bazar91-machine-shortlist"] && !Shopify.designMode) return;
  try {
    
function b91InitShortlists(root) {
  root.querySelectorAll('[data-b91-shortlist]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const select = section.querySelector('[data-b91-budget]');
    const cards = [...section.querySelectorAll('[data-b91-machine]')];
    const count = section.querySelector('[data-b91-result-count]');
    section.querySelector('[data-b91-budget-controls]').hidden = false;
    function filter() {
      let shown = 0;
      cards.forEach(card => {
        const price = Number(card.dataset.price);
        const show = select.value === 'all' || (select.value === 'low' && price >= 10000000 && price < 30000000) || (select.value === 'mid' && price >= 30000000 && price < 60000000) || (select.value === 'high' && price >= 60000000 && price <= 100000000);
        card.hidden = !show;
        if (show) shown++;
      });
      count.textContent = shown + ' ' + count.dataset.label;
      section.querySelector('[data-b91-empty]').hidden = shown !== 0;
    }
    select.addEventListener('change', filter);
    filter();
  });
}
b91InitShortlists(document);
document.addEventListener('shopify:section:load', () => b91InitShortlists(document));

  } catch(e) { console.error(e); }
})();
})();
